import React from 'react'

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info' | 'brand'

interface BadgeProps {
  children: React.ReactNode
  variant?: BadgeVariant
  dot?: boolean
  pulse?: boolean
  style?: React.CSSProperties
}

const variantStyles: Record<BadgeVariant, { color: string; bg: string }> = {
  default: { color: 'var(--text-secondary)', bg: 'var(--bg-tertiary)' },
  success: { color: 'var(--status-healthy)', bg: 'var(--status-healthy-dim)' },
  warning: { color: 'var(--status-warning)', bg: 'var(--status-warning-dim)' },
  error: { color: 'var(--status-unhealthy)', bg: 'var(--status-unhealthy-dim)' },
  info: { color: 'var(--status-provisioning)', bg: 'var(--status-provisioning-dim)' },
  brand: { color: 'var(--brand)', bg: 'var(--brand-dim)' },
}

export function Badge({ children, variant = 'default', dot, pulse, style }: BadgeProps) {
  const v = variantStyles[variant]
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '3px 10px',
        borderRadius: 'var(--radius-full)',
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        color: v.color,
        backgroundColor: v.bg,
        lineHeight: '1.4',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {dot && (
        <span
          className={pulse ? 'animate-pulse-dot' : undefined}
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: v.color,
            flexShrink: 0,
          }}
        />
      )}
      {children}
    </span>
  )
}
